import { useContext } from "react";
import { useInfiniteQuery } from "react-query";
import { AxiosContext } from "services/axios.context";

export const useUserPayouts = (size = 8) => {
  const { client } = useContext(AxiosContext);

  return useInfiniteQuery(
    ["payouts-history"],
    ({ pageParam = 1 }) =>
      client.get(`me/payouts/?page=${pageParam}&size=${size}`).then((resp) => {
        console.debug(`🤑 Payouts`);
        return resp.data;
      }),
    {
      getNextPageParam: (lastPage) =>
        lastPage.total / lastPage.size > lastPage.page
          ? lastPage.page + 1
          : null,
    }
  );
};
